var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"c-profile-upload",attrs:{"for":"file"}},[_vm._t("default"),_c('input',{attrs:{"id":"file","type":"file","accept":".json"},on:{"change":_vm.onFileChange}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }